import styled from 'styled-components';

// To be used along ModalBody in a flex-styled Modal
const ModalFooter = styled.div`
	margin-top: auto
`;

export default ModalFooter;
